import TransferErc20Action from "createProposal/action/TransferErc20Action"
import TransferNativeAssetAction from "createProposal/action/TransferNativeAssetAction"
import type { ExecutableCallInput } from "query/graphql"
import { ExecutableCallType } from "query/graphql"
import type { TokenBalances } from "common/types/tokenBalances"
import type { Action } from "createProposal/action/types"
import CustomAction from "createProposal/action/CustomAction"
import SwapAction from "createProposal/action/SwapAction"
import TransferArbitrumErc20Action from "createProposal/action/TransferArbitrumErc20Action"

export const getActions = async (
  chainId: string,
  governorId: string,
  executableCalls?: ExecutableCallInput[],
  tokenBalances?: TokenBalances,
): Promise<Action[] | undefined> => {
  if (!executableCalls) {
    return undefined
  }

  const actions = executableCalls.map(async (executableAction) => {
    switch (executableAction.type) {
      case ExecutableCallType.Nativetransfer:
        return TransferNativeAssetAction.from(executableAction, chainId)

      case ExecutableCallType.Erc20transfer:
        return TransferErc20Action.from(
          executableAction,
          chainId,
          tokenBalances,
        )

      case ExecutableCallType.Erc20transferarbitrum:
        return TransferArbitrumErc20Action.from(
          executableAction,
          chainId,
          tokenBalances,
        )

      case ExecutableCallType.Custom:
        return CustomAction.from(chainId, governorId, executableAction)

      case ExecutableCallType.Swap:
        return SwapAction.from(executableAction)
    }
  })

  const resolvedActions = (await Promise.all(actions)).filter(
    (resolvedAction) => Boolean(resolvedAction),
  )

  return resolvedActions as Action[]
}
